import styled from '@emotion/styled'
import { breakpoint, colors } from '../../..'
import { themedValue } from '../../../__styling'

export const StyledLiveEventTimeline = styled('div')(({ theme }) => ({
    overflow: 'auto',
    minHeight: '100vh',
    marginLeft: theme.margins.md * -1,
    marginRight: theme.margins.md * -1,
    background: themedValue(theme, {
        sevennews: theme.colors.palette.white,
        fallback: colors.thewest.greySeal,
    }),

    '& > div:first-of-type': {
        marginTop: theme.margins.md,
    },

    [breakpoint('md')]: {
        '& > div:first-of-type': {
            marginTop: themedValue(theme, {
                thewest: 0,
                perthnow: 0,
                sevennews: theme.margins.md,
                fallback: undefined,
            }),
        },
    },
}))
